// extracted by mini-css-extract-plugin
export default {"customAttributeContainer":"custom-attribute-container__custom-attribute-container__hCVIf"};